<div class="modal__content paysafemodal">
    <div class="modal__close" v-if="!isProcessing" @click="closeModal('paysafe')">
        <i class="fa-solid fa-xmark"></i>
    </div>
    <h1 class="center-section" v-if="!isFinished">{{ $t('modals.paysafe.title') }} {{ currencyCode !== 'EUR' ? currencyCode : '' }}</h1>
    <div class="finished" v-if="isFinished">
        <div class="failure" v-if="hasErrors">
            <h1 class="center-section">{{ $t('modals.paysafe.payment_failure')}}</h1>
            <div class="error center-section">
                <div class="error-title">{{ $t('modals.paysafe.error-title') }}</div>
                <div class="error-content">
                    <i class="fa fa-warning"></i>
                    {{ errors.message }}
                </div>
            </div>
        </div>
        <div class="success" v-if="!hasErrors">
            <h2 class="center-section">{{ $t('modals.paysafe.payment_succes')}}</h2>
            <div class="description center-section">{{ $t('modals.paysafe.payment_succes_desc', {sec : CLOSE_TIMEOUT_SEC})}}</div>
            <div class="center-section">
                <button class="btn btn-small mr" @click="close()">{{ $t('modals.paysafe.close') }}</button>
            </div>
        </div>
    </div>
    <div class="processing" v-if="isProcessing">
        <div class="processing__content">{{ $t('modals.paysafe.processing') }}</div>
    </div>
    <div class="paysafemodal__content" v-if="!isFinished">
        <form @submit="(ev, values) => onSubmit(ev, values)">
            <div class="row">
                <div class="col summary">
                    <span>{{ $t('modals.paysafe.description', {amount: $filters.shortCurrency(total, currencyCode), credits: $filters.niceCredits(credits + getBonus) } ) }}</span>
                    <span class="bonus" v-if="getBonus">{{ $t('modals.paysafe.bonusdesc', {bonus: $filters.niceCredits(getBonus) }) }}</span>
                </div>
            </div>
            <div class="card-information">
                <div class="row center-section">
                    <div class="col info">{{ $t('modals.paysafe.cardInformation') }}</div>
                    <div class="col brands">
                        <span class="fa-cards fa-cards-visa"></span>
                        <span class="fa-cards fa-cards-master"></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-lg form-group">
                        <label for="cardNumber">{{ $t('modals.paysafe.cardnumber') }}</label>
                        <div class="creditcard">
                            <div class="form-control card-number tabable" id="cardNumber" ref="cardNumber"></div>
                            <span class="card-addon" ref="cardAddon"><i ref="ccIcon" class="fa fa-credit-card"></i></span>
                        </div>
                        <div class="explain">
                            {{ $t('modals.paysafe.cardnumber_explain') }}
                            <span class="test" v-if="isTesting && scenarioSelected">{{ scenarioSelected.input.creditcard }}</span>
                        </div>
                    </div>
                    <div class="col form-group">
                        <label for="cardExpiry">{{ $t('modals.paysafe.cardexpires') }}</label>
                        <div id="cardExpiry" class="form-control tabable" ref="cardExpiry"></div>
                        <div class="explain">{{ $t('modals.paysafe.cardexpires_explain') }}</div>
                    </div>
                    <div class="col col-sm form-group">
                        <label for="cardCVC">{{ $t('modals.paysafe.cardcvc') }}</label>
                        <div id="cardCVC" class="form-control" ref="cardCVC"></div>
                        <span class="test" v-if="isTesting && scenarioSelected?.input?.cvc">{{ scenarioSelected.input.cvc }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col info">{{ $t('modals.paysafe.billingInformation') }}</div>
                </div>
                <div class="row">
                    <div class="col form-group">
                        <label for="firstName">{{ $t('modals.paysafe.firstname') }}</label>
                        <div class="form-control" :class="{alert: errors.firstName && firstNameMeta.dirty}">
                            <input type="text" v-model="firstName" id="firstName" maxlength="80" />
                            <div class="errorMessage" v-if="errors.firstName  && firstNameMeta.dirty">
                                <span class="arrow"></span>
                                {{ $t(errors.firstName) }}
                            </div>
                        </div>
                    </div>
                    <div class="col form-group">
                        <label for="lastName">{{ $t('modals.paysafe.lastname') }}</label>
                        <div class="form-control" :class="{alert: errors.lastName && lastNameMeta.dirty}">
                            <input type="text" v-model="lastName" id="lastname" maxlength="80" />
                            <div class="errorMessage" v-if="errors.lastName  && lastNameMeta.dirty">
                                <span class="arrow"></span>
                                {{ $t(errors.lastName) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col form-group">
                        <label for="street">{{ $t('modals.paysafe.billingStreet') }}</label>
                        <div class="form-control" :class="{alert: errors.street && streetMeta.dirty}">
                            <input type="text" id="street" v-model="street" maxlength="50" />
                            <div class="errorMessage" v-if="errors.street && streetMeta.dirty">
                                <span class="arrow"></span>
                                {{ $t(errors.street) }}
                            </div>
                        </div>
                    </div>
                    <div class="col form-group">
                        <label for="zipcode">{{ $t('modals.paysafe.billingZip') }}</label>
                        <div class="form-control" :class="{alert: errors.zipcode && zipcodeMeta.dirty}">
                            <input type="text" v-model="zipcode" id="zipcode" maxlength="10" />
                            <div class="errorMessage" v-if="errors.zipcode  && zipcodeMeta.dirty">
                                <span class="arrow"></span>
                                {{ $t(errors.zipcode) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col form-group" v-if="needsBillingInfo">
                        <label for="state">{{ country.code !== 'US' && country.code !== 'CA' ? $t('modals.paysafe.billingState') : $t('modals.paysafe.billingStateUS') }}</label>
                        <div class="form-control" v-if="country.code !== 'US' && country.code !== 'CA' ">
                            <input type="text" id="state" v-model="state" minlength="2" maxlength="40" :class="{alert: errors.state  && stateMeta.dirty}" />
                            <div class="errorMessage" v-if="errors.state && stateMeta.dirty">
                                <span class="arrow"></span>
                                {{ $t(errors.state) }}
                            </div>
                        </div>
                        <div class="form-control">
                            <select v-model="stateCA" v-if="country.code == 'CA'">
                                <option v-for="state in data.statesCA" :value="state.code">{{ state.name }}</option>
                            </select>
                            <select v-model="stateUS" v-if="country.code == 'US'">
                                <option v-for="state in data.statesUS" :value="state.code">{{ state.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col form-group">
                        <label for="city">{{ $t('modals.paysafe.billingCity') }}</label>
                        <div class="form-control">
                            <input type="text" id="city" v-model="city" maxlength="40" :class="{alert: errors.city  && cityMeta.dirty}" />
                            <div class="errorMessage" v-if="errors.city && cityMeta.dirty">
                                <span class="arrow"></span>
                                {{ $t(errors.city) }}
                            </div>
                        </div>
                    </div>
                    <div class="col form-group">
                        <label for="country">{{ $t('modals.paysafe.billingCountry') }}</label>
                        <div class="form-control" :class="{alert: errors.country && activeValidation}">
                            <countryPicker :default="country" :options="countriesModel" tabindex="0" @input="(country) => selectCountry(country)" @search-updated="(value) => filterCountry(value)"></countryPicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col payinfo center-section">{{ $t('modals.paysafe.paymentstatement', { merchant: merchantName}) }}</div>
            </div>
            <div class="row">
                <div class="error" v-if="hasErrors">
                    <i class="fa fa-warning"></i>
                    {{ errors.message }}
                </div>
            </div>
            <div class="row">
                <img src="../../../assets/images/logo-paysafe.svg" class="paySafeImg" />
            </div>
            <div class="row center-section">
                <button id="payNow" type="submit" class="pay btn btn-info btn-lg btn-block" :disabled="!isFormValid" :class="{'disabled': !isFormValid }">{{ $t('payment.paying') }}</button>
            </div>
        </form>
    </div>
</div>